exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("./appengine.icon.svg"));

// Module
exports.push([module.id, ".cloud-provider-logo .icon-appengine {\n  -webkit-mask-image: url(" + ___CSS_LOADER_URL___0___ + ");\n          mask-image: url(" + ___CSS_LOADER_URL___0___ + ");\n  background-color: #4285f4;\n}\n", ""]);

